export default "__VITE_ASSET__CFhZVmD1__"